/**
 * Generated runtime TestId mirror for frontend/src/pages/CreateFunctionGroup.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CreateFunctionGroupTestIds = {
  btnCancelCreateFunctionGroup: "btn-cancel-create-function-group",
  btnSubmitCreateFunctionGroup: "btn-submit-create-function-group",
  cardTitleCreateFunctionGroup: "card-title-create-function-group",
  inputFgDescription: "input-fg-description",
  selectFgType: "select-fg-type",
  option: (t_code: string) => `option-${t_code}`,
  optionPrefix: () => "option-" as TestIdPrefix
} as const;
